<template>
  <div class="schedules">
    <div v-for="(schedule, key) in schedules" :key="key">
      <label>{{ key.replace(/(^|-)(\w)/g, (match, p1, p2) => p2.toUpperCase()).replace(/([A-Z])/g, ' $1') }}</label>
      <ul class="next-times p-0 row">
        <li v-for="(next_time, index) in schedule.next_time || {}" :key="index" class="col-12 col-sm-6 col-md-4 col-lg-3 d-block">
          <div class="input-group pb-3">
            <input type="text" class="form-control" placeholder="Cronjob/seconds" :value="values?.[key]?.[index] || next_time" @change="handleChangeSchedule($event, key, index)" />
            <div class="input-group-append">
              <span class="input-group-text">{{ index }}</span>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    schedules() {
      return this.config?.schedules || {}
    },
    values() {
      return this.config?.values || {}
    }
  },
  methods: {
    handleChangeSchedule(e, key, index) {
      let values = { ...this.values }
      if (!values[key]) values[key] = {}
      values[key][index] = e.currentTarget.value
      this.$emit('changeValue', values)
    }
  },
  props: {
    config: Object
  }
}
</script>
